import { formatMoney, formatNumberWithDots, formatPercent } from '~/helpers'

import { ReportCampaigns } from './types'

export const formatIndustryReportCampaign = (
  data: GetCampaignsReportResponse
) => {
  const soldItemsClickValue = Number(
    data?.total_conversions_items_quantity_click
  )

  return {
    _raw: {
      originPath: 'src/modules/retailMedia/dtos/industry/campaign/report.ts'
    },
    ...data,
    formatted: {
      actives_advertisers: isNaN(data.total_advertisers)
        ? '-'
        : formatNumberWithDots(data.total_advertisers),
      actives_campaigns: isNaN(data.total_campaigns)
        ? '-'
        : formatNumberWithDots(data.total_campaigns),
      views: formatNumberWithDots(data?.views || 0),
      impressions: formatNumberWithDots(data?.impressions || 0),
      impressionShare:
        data?.impression_share == null
          ? '-'
          : formatPercent(Number(data.impression_share)),
      lostIsRank:
        data?.lost_is_rank == null
          ? '-'
          : formatPercent(Number(data.lost_is_rank)),
      lostIsBudget:
        data?.lost_is_budget == null
          ? '-'
          : formatPercent(Number(data.lost_is_budget)),
      clicks: formatNumberWithDots(data?.clicks || 0),
      newToBrandCustomers:
        data?.new_to_brand_customers == null
          ? '-'
          : formatNumberWithDots(Number(data.new_to_brand_customers)),
      newToBrandCustomersPercent:
        data?.new_to_brand_customers_percent == null
          ? '-'
          : formatPercent(Number(data.new_to_brand_customers_percent)),
      newToBrandRevenue:
        data?.new_to_brand_revenue == null
          ? '-'
          : formatMoney(Number(data.new_to_brand_revenue)),
      newToBrandRevenuePercent:
        data?.new_to_brand_revenue_percent == null
          ? '-'
          : formatPercent(Number(data.new_to_brand_revenue_percent)),
      conversions: formatNumberWithDots(data?.conversions || 0),
      conversion_rate: formatPercent(data?.conversion_rate || 0),
      ctr: formatPercent(data?.ctr || 0),
      roas: formatNumberWithDots(Number(data?.roas || 0)),
      income: formatMoney(Number(data?.income) || 0),
      total_spent: formatMoney(Number(data?.total_spent) || 0),
      balance: formatMoney(Number(data?.balance) || 0),
      adcost: formatPercent(Number(data?.adcost) || 0),
      conversions_click:
        data?.conversions_click == null
          ? '-'
          : formatNumberWithDots(Number(data.conversions_click)),
      conversion_rate_click:
        data?.conversion_rate_click == null
          ? '-'
          : formatPercent(Number(data.conversion_rate_click)),
      income_click:
        data?.income_click == null
          ? '-'
          : formatMoney(Number(data.income_click)),
      total_conversions_items_quantity_click:
        data?.total_conversions_items_quantity_click == null
          ? '-'
          : formatNumberWithDots(soldItemsClickValue),
      roas_click:
        data?.roas_click == null
          ? '-'
          : formatNumberWithDots(Number(data.roas_click)),
      halo_revenue: formatMoney(data?.assisted_income ?? Number.NaN),
      roas_halo: formatNumberWithDots(data?.assisted_roas ?? Number.NaN),
      halo_orders: formatNumberWithDots(data?.assisted_orders ?? Number.NaN),
      halo_items: formatNumberWithDots(data?.assisted_items ?? Number.NaN),
      roas_overall: formatNumberWithDots(
        data?.roas_overall ?? data?.overall_roas ?? Number.NaN
      )
    }
  } as ReportCampaigns
}
